import { useEffect } from 'react';
import noindexRoutes from '../data/noindexRoutes.json';

const DEFAULT_ROBOTS = 'index, follow';
const NOINDEX_ROBOTS = 'noindex, follow';

/** Vrai si le chemin figure dans la liste partagée des pages exclues de l'index (et du sitemap). */
export const isNoindexPath = (path: string): boolean => (noindexRoutes as string[]).includes(path);

/**
 * Pose `<meta name="robots" content="noindex, follow">` tant que `noindex` est vrai,
 * puis rétablit « index, follow » au démontage. Le prerender capture le résultat.
 */
export const useRobotsMeta = (noindex: boolean) => {
  useEffect(() => {
    if (!noindex) return;

    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', NOINDEX_ROBOTS);

    return () => {
      document.head.querySelector('meta[name="robots"]')?.setAttribute('content', DEFAULT_ROBOTS);
    };
  }, [noindex]);
};
